import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../component/Select/BaseSelectorReadonlyToInput";

class CheckpointTypeSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      label: 'name',
      title: 'Tipo',
      items: [
        {id: 'DEFAULT', name: 'Padrão'},
        {id: 'COMMISSIONER', name: 'Comissionador'}]
    };
  }
}

CheckpointTypeSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckpointTypeSelector;
// withTracker(() => {
//   const items = Utils.enumTypesToArray(Checkpoints.Type);
//   // console.log('[CP type selector] items: ', items);
//   const subscription = {
//     ready: () => true
//   };
//   return {
//     subscription,
//     items,
//     title: 'Type'
//   };
//
// })(CheckpointTypeSelector);



// WEBPACK FOOTER //
// ./src/checkpoint/CheckpointTypeSelector.js